import { ChangeDetectionStrategy, Component, HostListener, Inject } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Tag } from "@vp/models";

export interface DialogData {
  tag: Tag;
  planName: string;
  mode: "add" | "edit";
}

@Component({
  selector: "vp-add-cost-pricing-plan-dialog",
  standalone: false,
  templateUrl: "./add-cost-pricing-plan-dialog.component.html",
  styleUrls: ["./add-cost-pricing-plan-dialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddCostPricingPlanDialogComponent {
  form!: UntypedFormGroup;

  @HostListener("window:keyup.esc") onKeyUp() {
    this.close(false);
  }

  @HostListener("window:beforeunload", ["$event"]) unloadHandler(event: Event) {
    event.returnValue = false;
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private readonly dialogRef: MatDialogRef<AddCostPricingPlanDialogComponent>,
    readonly formBuilder: UntypedFormBuilder
  ) {
    this.form = formBuilder.group({
      planName: [data.planName ?? null, Validators.required]
    });
  }

  onCancel = () => {
    this.close(false);
  };

  onSave = () => {
    this.close(true);
  };

  close(save: boolean) {
    if (save && this.form.valid) {
      this.dialogRef.close(this.form.getRawValue().planName);
    } else {
      if (this.form.pristine || this.form.invalid) {
        this.dialogRef.close();
      } else {
        if (confirm("Are you sure you want to cancel and potentially lose data?")) {
          this.dialogRef.close();
        }
      }
    }
  }
}
